import { z } from 'zod'
import { AsyncFn } from '../../common'
import { guidSchema } from '../../contracts/_common'

/**
 * Represents a user's assignment to a business unit over a time period
 */
export const userBusinessUnitSchema = z.object({
  userBusinessUnitGuid: guidSchema,
  companyGuid: guidSchema,
  userGuid: guidSchema,
  businessUnitGuid: guidSchema,
  dateStart: z.string(), // ISO date: 'YYYY-MM-DD'
  dateEnd: z.string().nullable(),
  createdAt: z.string(),
})

export type UserBusinessUnit = z.infer<typeof userBusinessUnitSchema>

/**
 * Repository interface for user business unit assignments
 */
export interface IUserBusinessUnitRepository {
  /**
   * Get the current (active) business unit for a user
   * Returns null if no active assignment exists
   */
  getCurrentBusinessUnit(input: { companyGuid: string; userGuid: string }): Promise<string | null>

  /**
   * Upsert a user's business unit assignment
   * - If assignment exists with same dateStart, updates it
   * - Otherwise, creates new assignment and end-dates previous ones
   */
  upsert(input: {
    companyGuid: string
    userGuid: string
    businessUnitGuid: string | null
    dateStart: string // ISO date: 'YYYY-MM-DD'
    actorUserGuid: string
  }): Promise<void>
}

export type UserBusinessUnitReader = AsyncFn<{ companyGuid: string; userGuid: string }, UserBusinessUnit | null>
